import React, { useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapPin } from '@fortawesome/free-solid-svg-icons';

const Form = ({
    emailValue,
    nameValue,
    subjectValue,
    messageValue,
    phoneValue,
    setEmail,
    setName,
    setSubject,
    setMessage,
    setPhone,
}) => {
    const [isChecked, setIsChecked] = useState(false);

    const formReset = () => {
        setEmail("");
        setName("");
        setSubject("");
        setMessage("");
        setPhone("");
        setIsChecked(false);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const SERVER = "https://www.edilpagotto.it/mail.php";

        let formData = new FormData();
        formData.append("email", emailValue);
        formData.append("name", nameValue);
        formData.append("subject", subjectValue);
        formData.append("phone", phoneValue);
        formData.append("message", messageValue);
        formData.append("send_mail", "1");

        axios
            .post(SERVER, formData)
            .then((response) => {
                formReset();
            })
            .catch((err) => console.log(err));
    };

    return (
        <>
            <p className="display-6 about-title title fw-semibold c-title">CONTATTCI</p>
            <div id="contatti">
                <div className="parent-container">
                    <div className="contact-content">
                        <p className="fs-4 text fw-semibold contact-title">
                            I NOSTRI CONTATTI
                        </p>
                        <div className="contacts">
                            <a className="fs-5 text" href="tel:3494158040">
                                <FontAwesomeIcon icon={faPhone} /> tel: 349 4158040
                            </a>
                            <a className="fs-5 text" href="mailto:edilpagotto@virgilio.it">
                                <FontAwesomeIcon icon={faEnvelope} />E-mail: edilpagotto@virgilio.it
                            </a>
                            <a href="https://maps.app.goo.gl/pnKxMXd2pzzwb3WS6" className="fs-5 text">
                                <FontAwesomeIcon icon={faMapPin} />30036 Santa Maria di Sala - VE
                            </a>
                        </div>
                    </div>
                </div>
                <div className="form-content">
                    <p className="fs-4 text fw-semibold form-title">
                        INVIACI UNA MAIL
                    </p>
                    <form className="form" onSubmit={handleSubmit}>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label htmlFor="name" className="form-label">Nominativo</label>
                                <input type="text" className="form-control" name="name" required value={nameValue} onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="email" className="form-label">Indirizzo Email</label>
                                <input type="email" className="form-control" name="email" required value={emailValue} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label htmlFor="phone" className="form-label">Telefono</label>
                                <input type="tel" className="form-control" name="phone" required value={phoneValue} onChange={(e) => setPhone(e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="subject" className="form-label">Oggetto</label>
                                <input type="text" className="form-control" name="subject" required value={subjectValue} onChange={(e) => setSubject(e.target.value)} />
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="message" className="form-label">Messaggio</label>
                            <textarea className="form-control" name="message" rows="3" required value={messageValue} onChange={(e) => setMessage(e.target.value)}></textarea>
                        </div>
                        <div className="mb-3">
                            <input type="checkbox" name="check" checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} />
                            <label htmlFor="check" className="form-label">Ho letto le norme della <a href="./privacy_policy.html" target="_blank">Privacy Policy</a></label>
                        </div>
                        <button type="submit" className="btn btn-danger w-100" disabled={!isChecked}>Invia</button>
                    </form>
                </div>
            </div >
        </>
    );
};

export default Form;
